import {defineStore} from 'pinia'
import {useUserStore} from "@/stores/user";
import controller from "@/controller/applicationController";

export const useApplicationStore = defineStore('application', {
    state: () => {
        return {
            currentId: '',
            current: {}
        }
    },
    getters: {},
    actions: {
        async findById(id){
           return  await controller.findById({id});
        },
        async getList(keyword) {

            if (!useUserStore().getCompanySelected)
                return new Promise((resolve, reject) => {
                    resolve({data: []})
                });

            return await controller.list({
                keyword,
                company_id: useUserStore().getCompanySelected
            })
        },
        copy(application_id, company, name) {
            return controller.copy({id: application_id, company, name});
        },
        async delete(id) {
            await controller.delete(id);
        },
        async post(obj) {
            obj.company_id = useUserStore().getCompanySelected;
            return await controller.post(obj)
        },
        async setCurrentApp(id) {
            this.currentId = id;
            await controller.findById({id}).then(({data}) => {
                this.current = data
            });
        },
        getCurrent() {
            return this.current;
        },
        getCurrentId() {
            return this.currentId;
        },
    },
    persist: {
        enabled: false
    }
})